import styled, {keyframes} from 'styled-components';


const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity:1;
  }
`;

export const CardSinBannerDiv = styled.div `
width: 80%;
margin-left: 10%;
margin-top: 5%;
background: var(--Color-Blanco);
border-radius: 24px;
padding: 50px;
box-shadow: 0px -1px 30px -4px rgba(127, 127, 127, 0.26);

& > p{
    font-family: var(--Font-Display-Regular);
    color: var(--Color-Red-Primary);
    font-size: 16px;
    line-height: 28px;
    text-align: center;
    margin-bottom: 0;
}
`

export const LabelInput = styled.label`
    font-family: var(--Font-Display-Regular);
    font-size: 14px;
    color: var(--Color-Grey-Dark);
`

export const TextArea = styled.textarea`
    border: 1px solid var(--Color-Grey-Light);
    width: 100%;
    border-radius: 14px;
    margin-top: 1%;
    padding: 30px;
    transition: all .25s linear;
    box-shadow: none;
    &::placeholder{
        font-family: var(--Font-Display-Regular);
        font-size: 14px;
        color: var(--Color-Grey-Dark);
    }

    &:focus-visible{
        box-shadow: 1px 1px 1px 1px var(--Color-Green-Aproved) !important;
        outline: 1px solid var(--Color-Green-Aproved) ;
    }
`
export const DivTextEnd = styled.div`
    text-align: end;

`


export const SmallContadorAproved = styled.small`
    color: var(--Color-Green-Aproved);
    font-size: 10px;
    font-family: var(--Font-Display-Regular);
    width: 100%;
    text-align: right;

`

export const SmallContadorAlert = styled.small`
    color: var(--Color-Red-Primary);
    font-size: 10px;
    font-family: var(--Font-Display-Regular);
`

export const LabelColorRojo = styled.label`
    width: 90%;
    margin-left: 5%;
    height: 80px;
    background: #E42B31;
    transition: all .25s linear;
    cursor: pointer;
`

export const LabelColorNegro = styled.label`
    width: 90%;
    margin-left: 5%;
    height: 80px;
    background: #000;
    transition: all .25s linear;
    cursor: pointer;
`

export const LabelColorGris = styled.label`
    width: 90%;
    margin-left: 5%;
    height: 80px;
    background: #7F7F7F;
    transition: all .25s linear;
    cursor: pointer;
`

export const ShowBannerTexto = styled.div`
    padding: 50px;
    font-size: 10px;
    & > p {
        font-family: var(--Font-Display-Regular);
        color: var(--Color-Blanco);
        margin-bottom: 0px;
        font-size: 16px;
        text-align: center;
    }

`

export const ErrorValueInput = styled.span`
    color: var(--Color-Red-Primary);
    font-family: var(--Font-Display-Regular);
    margin-left: 2%;
    font-weight:bold;
    font-size: 12px;
    
`

export const ContentMsgError = styled.div`
    animation: ${opacity} 1s ease;
    position: relative;
`

export const CardTexto = styled.div`
    width: 100%;
    background: var(--Color-Blanco);
    border-radius: 20px;
    padding: 25px 10px;
    box-shadow: 0px -1px 30px -4px rgba(127, 127, 127, 0.26);
`

export const TituloCardTexto = styled.p`
    color: var(--Color-Negro);
    font-family: var(--Font-Display-Bold);
    font-size: 14px;
    margin-bottom: 0;

    & > span{
        font-family: var(--Font-Display-Regular);
        color: var(--Color-Grey-Dark);
        font-size: 14px;
    }
`

export const CardSinDatos = styled.div `
    width: 80%;
    margin-left: 10%;
    margin-top: 5%;
    background: var(--Color-Blanco);
    border-radius: 24px;
    padding: 50px;
    box-shadow: 0px -1px 30px -4px rgba(127, 127, 127, 0.26);

    & > p{
        font-family: var(--Font-Display-Regular);
        color: var(--Color-Red-Primary);
        font-size: 16px;
        line-height: 28px;
        text-align: center;
        margin-bottom: 0;
    }
`

export const EstadoActivo = styled.p`
    font-family: var(--Font-Display-Bold);
    font-size: 14px;
    color: var(--Color-Green-Aproved);
    margin-bottom: 0;
    & > span {
        color: var(--Color-Negro);
    }

`

export const EstadoInactivo = styled.p`
    font-family: var(--Font-Display-Bold);
    font-size: 14px;
    color: var(--Color-Red-Primary);
    margin-bottom: 0;
    & > span {
        color: var(--Color-Negro);
    }

`

export const LabelInputImagen = styled.label`
    background: var(--Color-Red-Primary);
    display: flex;
    justify-content: center;
    padding: 20px 10px;
    color: var(--Color-Blanco);
    width: 80%;
    margin: auto;
    border-radius: 10px;
    font-family: var(--Font-Display-Regular);
    transition: all .25s linear;
    font-size: 14px;
    cursor: pointer;
    &:hover{
        color: var(--Color-Red-Primary);
        background: var(--Color-Blanco);
    }
`

export const LeyendaInputImagen = styled.p`
    color: var(--Color-Grey-Dark);
    font-family: var(--Font-Display-Regular);
    font-size: 12px;
    margin: 1% 0;
    width: 90%;
    margin: 1% auto;

`

export const SinImagenCategoria = styled.div `
    background: #FFFFFF;
    border: 1.33333px solid #EBEBEB;
    box-sizing: border-box;
    box-shadow: 0px -1.33333px 40px -5.33333px rgba(127, 127, 127, 0.26);
    border-radius: 20px;
    text-align: center;
    padding: 20px;

    & > i {
        font-size: 60px;
        color: var(--Color-Red-Primary);
    }

    & > p {
        font-size: 12px;
        color: var(--Color-Red-Primary);
        font-family: var(--Font-Display-Regular);
        margin-bottom: 0;
    }
`





